import jwtAuthAxios from "../auth/jwtAuth";

const dashboardServices = {};

dashboardServices.getDashboards = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/automations/dashboards${params}`);
    return data;
};

dashboardServices.getDashboard = async (id, params = "") => {
    const { data } = await jwtAuthAxios.get(`/automations/dashboards/${id}${params}`);
    return data;
};

dashboardServices.createDashboard = async (body = {}, params = "") => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards${params}`, body);
    return data;
};

dashboardServices.updateDashboard = async (id, body = {}, params = "") => {
    const { data } = await jwtAuthAxios.put(`/automations/dashboards/${id}${params}`, body);
    return data;
};

dashboardServices.deleteDashboard = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/automations/dashboards/${id}`);
    return data;
};

dashboardServices.getEditOptions = async () => {
    const { data } = await jwtAuthAxios.get(`/automations/dashboards/edit_options`);
    return data;
};

dashboardServices.reorderSections = async (dashboardId, sectionIds = []) => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards/${dashboardId}/reorder_sections`, {
        section_ids: sectionIds,
    });
    return data;
};

dashboardServices.createSection = async (dashboardId, body = {}) => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards/${dashboardId}/sections`, body);
    return data;
};

dashboardServices.updateSection = async (dashboardId, sectionId, body = {}) => {
    const { data } = await jwtAuthAxios.put(`/automations/dashboards/${dashboardId}/sections/${sectionId}`, body);
    return data;
};

dashboardServices.deleteSection = async (dashboardId, sectionId) => {
    const { data } = await jwtAuthAxios.delete(`/automations/dashboards/${dashboardId}/sections/${sectionId}`);
    return data;
};

dashboardServices.reorderWidgets = async (dashboardId, sectionId, widgetIds = []) => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards/${dashboardId}/sections/${sectionId}/reorder_widgets`, {
        widget_ids: widgetIds,
    });
    return data;
};

dashboardServices.createWidget = async (dashboardId, body = {}) => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards/${dashboardId}/widgets`, body);
    return data;
};

dashboardServices.updateWidget = async (dashboardId, widgetId, body = {}) => {
    const { data } = await jwtAuthAxios.put(`/automations/dashboards/${dashboardId}/widgets/${widgetId}`, body);
    return data;
};

dashboardServices.deleteWidget = async (dashboardId, widgetId) => {
    const { data } = await jwtAuthAxios.delete(`/automations/dashboards/${dashboardId}/widgets/${widgetId}`);
    return data;
};

dashboardServices.previewWidget = async (dashboardId, body = {}) => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards/${dashboardId}/widgets/preview`, body);
    return data;
};

dashboardServices.queryWidget = async (dashboardId, widgetId, body = {}) => {
    const { data } = await jwtAuthAxios.post(`/automations/dashboards/${dashboardId}/widgets/${widgetId}/query`, body);
    return data;
};

export default dashboardServices;
